export default __webpack_public_path__ + "static/media/green_card_icon.e4d874a6.svg";